import React from 'react';
import AuthenticatedPage from "../../ContextAndHOC/AuthenticatedPage";
import { withStyles, Button, withWidth } from '@material-ui/core';
import PropTypes from 'prop-types';
import ErrorDialogsuccess from '../../components/ErrorDialog';
import SuccessDialog from '../../components/SuccessDialog';
import {StatusCodes} from 'http-status-codes';
import CircularProgress from '@material-ui/core/CircularProgress';
import CommonDashboard from '../../components/CommonDashBord';
import JsonPreview from '../PreviewTrivia';
import ChapterPreview from './CurriculumPreview';
import Title from '../../components/CommonDashboardTitle';
import {buildData, handleError} from "../../components/DeleteRecurring";

const styles = theme => ({
    root: {marginTop: theme.spacing(3),...theme.mixins.gutters(),paddingTop: theme.spacing(1),paddingBottom: theme.spacing(1),},
    primaryBtn: { color: theme.palette.text.textPrimaryColor, backgroundColor: theme.palette.primary.main,
    border: `1px solid${theme.palette.border.primaryBorder}`, borderRadius: "50px", margin: "8px 0", textAlign: "right", padding: "7px 20px",
    textTransform: "uppercase", '&:hover': { backgroundColor: theme.palette.hoverPrimaryColor.main, color: theme.palette.text.hoverTextPrimaryColor, border: `1px solid ${theme.palette.border.hoverPrimaryBorder}` } },
    pad0: { padding: 0 },
     tableStyle: {maxWidth: "1200px", margin: '0px auto', padding: "0",[theme.breakpoints.down("sm")]: {margin: 0 }},
    loadingBody:{minHeight:'100vh'},
});

const CurriculumList =(props)=>{

    const[Curriculumdata,setCurriculumData]=React.useState([]);
    const[totalCurriculumList,setTotalCurriculumList]=React.useState(0);
    const[open,setOpen]=React.useState(false);
    const[versionNumber,setversionNumber]=React.useState(null);
    const[deleteMessage,setdeleteMessage]=React.useState('');
    const[deleteDialogStatus,setdeleteDialogStatus]=React.useState(false);
    const[dialogueLoad,setdialogueLoad]=React.useState(false);
    const[id,setid]=React.useState("");
    const[openpreview,setOpenpreview]=React.useState(true);
    const [openpopup, setOpenpopup] = React.useState(false);
    const [chapterpreviewdata, setChapterPreviewdata] = React.useState();
    const [newchapterpreview, setNewchapterpreview] = React.useState(false);
    const[values,setValues]=React.useState([]);
        let reqAttentionFilter="1";
        let loading=true;
React.useEffect(()=>{
 if(chapterpreviewdata){
setNewchapterpreview(true);
  setOpenpreview(true);
}
},[chapterpreviewdata]);
const  handleEditUserCurriculum = (resourceid,variant,version, clone,newversion_clone) => {
    const selectedarticle =Curriculumdata.filter((n) => n.resourceid === resourceid);
    const Curversiondata=selectedarticle.filter((n) =>n.versionNumber === version);
    if(!clone){
        props.history.push({
            pathname: `./Curriculum/Edit/${resourceid}/${variant}`,
            clone,newversion_clone,
            state: { detail:Curversiondata }
          });
    } else {
        props.history.push({
            pathname: `./Curriculum/Edit/Clone/${resourceid}/${variant}`,
            clone,newversion_clone,
            state: { detail:Curversiondata }
          });
    }
    };
const handleClosechapter= () => {
 setOpenpreview(false);
 setNewchapterpreview(false);
setChapterPreviewdata();
};
 const handleClose = () => {
    setOpenpreview(false);
    setOpenpopup(false);
  };
const handlecurriculumpreview=(resourceid,version)=>{
const selectedcurriculum = Curriculumdata.filter((n) => n.resourceid === resourceid );
const curpreviewdata=selectedcurriculum.filter((n) =>n.versionNumber === version);
setOpenpreview(true);
setOpenpopup(true);
setValues(curpreviewdata[0]);
};
const  handleCurriculumdeletepopup=(resourceid, version)=>{
    setOpen(true);
    setid(resourceid);
    setversionNumber(version);
};
    const handleDeleteUserCurriculum = async () => {
        setOpen(false);
        setdialogueLoad(true);
        let response = await props.authenticatedApiCall('post', '/api/content/contentservice/deleteCurriculumResource', buildData(Curriculumdata, id, versionNumber));
        setdialogueLoad(false);
        setdeleteDialogStatus(true);
        const ErrorMsg = handleError(response);
        setdeleteMessage(ErrorMsg)
    };
 const handleCloseDialogCurriculum = () => {
     setOpen(false);
  };
React.useEffect(()=>{
         async function getcurriculum() {
        let response = await props.authenticatedApiCall('get', '/api/content/contentservice/getCurriculumResource', null);
        if (response && response.status === StatusCodes.OK) {
            setTotalCurriculumList(response.data.data.length);
            setCurriculumData(response.data.data);
        } else {
            setCurriculumData([]);
        }
        }
        getcurriculum();
    },[]);
const handleAddNewCurriculum = () => {
 props.history.push({pathname: "./Curriculum/New",state: { length:totalCurriculumList }});
};
    const handleDeleteDialogClose = () => {
        props.history.go(0);
    }
        const { classes} = props;
            const okbutton = [
      <Button className={classes.primaryBtn} onClick={handleCloseDialogCurriculum} >No</Button>,
      <Button className={classes.primaryBtn} onClick={handleDeleteUserCurriculum}>Yes</Button>
    ];
    const deleteDialogButton = [ <Button className={classes.primaryBtn} onClick={handleDeleteDialogClose}>Close</Button> ];
    const errorMessage = "Are you sure you want to delete this Curriculum?";
        return (
            <div>
                <div className={classes.tableStyle}>
                 <Title titlename={"Curriculum"} count={totalCurriculumList}  button3={handleAddNewCurriculum}/>
                    {(totalCurriculumList===0 &&loading) && <div className={classes.loadingBody}>
                    <CircularProgress color="primary" style={{position: "absolute",left: "50%",top:"50%"}}/></div>}
                {Curriculumdata &&Curriculumdata.length>0?
                <CommonDashboard  patientList = {Curriculumdata} reqAttentionFilter={reqAttentionFilter} handleEditUser={handleEditUserCurriculum}
                handleDeleteUser={handleCurriculumdeletepopup}  handleAddNewPatient={handleAddNewCurriculum} name={"curriculum"} handlepreview={handlecurriculumpreview}/>:""}
                </div>
                {open? <ErrorDialogsuccess successButton={okbutton}  HeaderText={errorMessage}  dismiss={handleCloseDialogCurriculum}/>:""}
                {deleteDialogStatus && <SuccessDialog successButton={deleteDialogButton} HeaderText={"Success"} BodyText={deleteMessage}  dismiss={handleDeleteDialogClose}/>}
                {dialogueLoad && <div className={classes.loadingBody}> <CircularProgress color="primary" style={{position: "absolute",left: "50%",top:"75%"}}/></div>}
                {openpopup ? (<JsonPreview open={openpreview} handleClose={handleClose} value={values}  name="curriculum" setChapterPreview={setChapterPreviewdata}/>) : ( "" )}
                {newchapterpreview?<ChapterPreview open={openpreview} handleClose={handleClosechapter} value={chapterpreviewdata}/>:"" }
            </div>
        );
    };

CurriculumList.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withWidth()((withStyles(styles)(AuthenticatedPage()(CurriculumList))));